import React, { useEffect, useMemo, useReducer } from 'react'
import { Form, Select, Radio, Space, Typography, Button } from 'antd'
import { profileScreen } from '../../../../translates'
import { AppConfig } from '../../../../AppConfig'
import './LegalFormItem.css'
import ModalDrawerPopup from '../../ModalDrawerPopup/ModalDrawerPopup'
import { createApiDataFromForm, simpleReducer } from '../../../../helper'
import TaxSystemItem from '../TaxSystemItem/TaxSystemItem'
import { useMutatePartnerProfileCheck } from '../../../../api/react-query/partners'

const { Title } = Typography
const { Option } = Select
const initialState = {
  isOpen: false,
  value: null
}

function LegalFormItem ({
  form,
  profile,
  isSuccess = false,
  isWarning = false,
  disabled = false,
  isTaxSystemRequired = false,
  label = profileScreen.input.legalForm.label
}) {
  const [state, setState] = useReducer(simpleReducer, initialState)

  const {
    data: profileChecked,
    mutate: doFetchProfileCheck,
    // isError: isErrorProfileChecked,
    isLoading: isLoadingProfileChecked
  } = useMutatePartnerProfileCheck()

  const taxSystemRequired = useMemo(() => {
    if (isTaxSystemRequired ||
        (profileChecked?.isSuccess && state.value === AppConfig.legalFormLabels.individual) ||
        profile?.personalData?.taxSystemRequired
    ) {
      return isTaxSystemRequired ||
          profileChecked?.profile?.personalData?.taxSystemRequired ||
          profile?.personalData?.taxSystemRequired
    } else {
      return false
    }
  }, [profileChecked, state.value, isTaxSystemRequired, profile?.personalData])

  const icon = useMemo(() => {
    return (
      <div className='legal-select-icon'>
        {isSuccess && <img src='/img/checkCircle.png' className='mr-3' />}
        {isWarning && <img src='/img/exclamationCircle.png' className='mr-3' />}
        <img src='/img/down-icon.png' />
      </div>
    )
  }, [isSuccess, isWarning])

  const handleClickLegal = (e) => {
    if (!disabled) {
      setState({ isOpen: true })
    }
  }

  const handleChangeRadio = (e) => {
    setState({ value: e.target.value })
    if (e.target.value === AppConfig.legalFormLabels.individual) {
      const values = form.getFieldsValue()
      values.personalData = {
        ...values.personalData,
        [profileScreen.input.legalForm.name]: e.target.value
      }
      const info = createApiDataFromForm(values)
      doFetchProfileCheck({ info })
    }
    form.setFieldsValue({
      personalData: {
        [profileScreen.input.legalForm.name]: e.target.value
      }
    })
  }

  const handleClose = () => {
    setState({ isOpen: false })
  }

  const handleOk = () => {
    setState(initialState)
  }

  useEffect(() => {
    const legalForm = form?.getFieldValue(['personalData', profileScreen.input.legalForm.name])
    if (legalForm) {
      setState({ value: legalForm })
    }
  }, [state.isOpen])

  return (
    <div className='legal-form'>
      <Form.Item
        name={['personalData', profileScreen.input.legalForm.name]}
        label={label}
        rules={[{ required: profile?.personalData?.required, message: profileScreen.input.legalForm.message }]}
      >
        <Select
          size='large'
          placeholder='Выберите статус'
          onClick={handleClickLegal}
          suffixIcon={icon}
          dropdownStyle={{ display: 'none' }}
          disabled={disabled}
        >
          {
            AppConfig.legalForms.map(c => <Option key={c} value={c}>{c}</Option>)
          }
        </Select>
      </Form.Item>
      {taxSystemRequired && <TaxSystemItem form={form} />}
      <ModalDrawerPopup
        className='legal-form-popup'
        isOpen={state.isOpen}
        onClose={handleClose}
        maskClosable
        destroyOnClose
        drawerHeight='auto'
      >
        <Title level={3}>{label}</Title>
        <Radio.Group value={state.value} onChange={handleChangeRadio} size='large'>
          <Space direction='vertical'>
            {
              AppConfig.legalForms.map(c => <Radio key={c} value={c}>{c}</Radio>)
            }
          </Space>
        </Radio.Group>
        <Button
          type='primary'
          size='large'
          className='continue-button'
          onClick={handleOk}
          loading={isLoadingProfileChecked}
        >
          Продолжить
        </Button>
      </ModalDrawerPopup>
    </div>
  )
}

export default LegalFormItem
